// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2n5A8","cell":"ColumnAccessor_cell__3RL2n","firstCellAccent":"ColumnAccessor_firstCellAccent__1lIRc"};